import { ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IdVerificationService } from 'src/app/library/services/idv.service';
import { environment } from 'src/environments/environment';
// import { DialogConfig } from '../../configs/dialog-config';
// import { IdVerificationService } from '../../services/id-verification.service';
// import { DialogComponent } from '../dialog/dialog.component';

export enum VerificationStatus {
  ToRegister = 'to_register',
  ThankYouPage = 'thankyou_page',
}

@Component({
  selector: 'eh-idv-sdk',
  templateUrl: './idv-sdk.component.html',
  styleUrls: ['./idv-sdk.component.scss']
})
export class IDVSDKComponent{

  @Input()
  uuid: string = '';

  @Input()
  qrCodeLink: string = '';

  // onboardingUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.idVerificationUrl);
  incode: any;
  session: any;

  incodeConfig = {
    apiURL: environment.idv.apiUrl, 
    apiKey: environment.idv.apiKey 
  };

  container: any;

  flowId: string = environment.idv.flowId;

  interviewId: string = '';

  qrCodeUrl: string = '';

  loading: boolean = false;
  loadingText: string = "Hello";

  @Output()
  idVerificationCompleted: EventEmitter<any> = new EventEmitter();

  @Output()
  sessionCreated: EventEmitter<any> = new EventEmitter();

  @Output()
  rejectTermsConditions: EventEmitter<any> = new EventEmitter();


  @ViewChild("termsAndConditions") termsAndConditions: TemplateRef<any> = {} as TemplateRef<any>;

  termsDialogConfig: any = {
    dialogTitle: 'Terms and Conditions',
    dialogContent: undefined,
    secondaryButtonText: "Cancel",
    disableClose: true
  }
  
  private mobileDevices = ['Android', 'iPhone', 'iPad', 'iPod', 'Windows Phone'];
  
  constructor(
    private idvService: IdVerificationService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    this.callStartIdVerification();
    this.cdRef.detectChanges();
      //Open only in desktop
      // if(this.isDesktop()) {
      //   this.openTermsandCondition()
      // } else {
      //   this.callStartIdVerification();
      // }
  }

  isMobile(): boolean {
    return this.mobileDevices.some(device => navigator.userAgent.includes(device));
  }

  isDesktop(): boolean {
    return !this.isMobile();
  }

  async callStartIdVerification() {
    this.container = document.getElementById("camera-container");
    try{
      if(this.container) {
        this.loading = true;
        this.loadingText = 'Initializing ID Verification'
        // this.container.innerHTML = `<p>Starting incode...</p>`;
        this.incode = await this.startIncode();
        this.loadingText = 'Creating ID Verification Session'
        // this.container.innerHTML = `<p>Creating session...</p>`;
        this.session = await this.createIncodeSession();
        this.loading = false;
        if(!this.uuid) {
          this.sessionCreated.emit(this.session)
        }        
        await this.incode
          .sendGeolocation({ token: this.session.token })
          .catch(console.log);
        if (this.incode.isDesktop()) {
          const url = this.qrCodeLink ? this.qrCodeLink : window.location.href;
          this.incode.renderRedirectToMobile(this.container, {
            onSuccess: () => {
              // showFinishScreen();
              this.idVerificationCompleted.emit(VerificationStatus.ToRegister);

            },
            session: this.session,
            flowId: this.flowId,
            showSms: false,
            url: url
          });
        } else {

          // this.renderFrontIDCamera();
          this.renderFrontIDCamera();
          // this.renderDocumentSelector()
        }
      }
      
    }catch (e){
        console.dir(e);
        if(this.container) {
          this.container.innerHTML = `<p>Something went wrong</p>`;
        }
        throw e;
    }
  }

  // openTermsandCondition() {

  //   this.termsDialogConfig.dialogContent = this.termsAndConditions;
  //   let dialogConfig: MatDialogConfig = { data: this.termsDialogConfig, disableClose: true, minHeight: '80%', minWidth: '80%', backdropClass: 'bg-white', position: { top: '5%' } };
  //   const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
  //   dialogRef.componentInstance?.primaryAction?.subscribe(async () => {
  //     // await this.captureScreenShare()
  //     dialogRef.close();
  //     this.callStartIdVerification();
  //   });
  //   dialogRef.componentInstance?.secondaryAction?.subscribe(() => {
  //     this.rejectTermsConditions.emit();
  //     dialogRef.close();
  //     // Navigate to start verirification page
  //     // this.router.navigate(['test/auth/' + this.testId])
  //   });
  // }

  onCheckboxChange(event: any) {
    if (event.checked) {
      this.termsDialogConfig.primaryButtonText = 'Start Verification';
    } else {
      this.termsDialogConfig.primaryButtonText = undefined;
    }
    this.cdRef.detectChanges();
  }
  async startIncode() {
    // Cast window to any to avoid TypeScript error about OnBoarding property
    let incodeObj = await (window as any).OnBoarding.create(this.incodeConfig);
    await incodeObj.warmup();
    return incodeObj;
  }

  // async createIncodeSession(){
  //   if(!this.incode.isDesktop() && this.uuid) {

  //       this.idVerificationService.fetchSessionDetails(this.uuid).subscribe(
  //         (data: any) => {
  //           if(data) {
  //             return data;
  //             // return this.incode.createSession("ALL", null, { 
  //             //   "configurationId" : this.flowId,
  //             //   "interviewId": data.interviewId
  //             // });
  //           }
  //         }
  //       )
  //   } else {
  //     console.log("inside desktop version")
  //     return this.incode.createSession("ALL", null, { "configurationId" : this.flowId });
  //   }
  // }

  async createIncodeSession() {
    if (!this.incode.isDesktop() && this.uuid) {
      return new Promise((resolve, reject) => {
        this.idvService.fetchSessionDetails(this.uuid).subscribe({
          next: async (data: any) => {
            if (data) {
              try {
                // const session = await this.incode.createSession("ALL", null, { 
                //   configurationId: this.flowId,
                //   interviewId: data.interviewId
                // });
                resolve(data);
              } catch (error) {
                reject(error);
              }
            } else {
              reject(new Error('No data found'));
            }
          },
          error: (error: any) => {
            reject(error);
          }
        });
      });
    } else {
      try {
        const session = await this.incode.createSession("ALL", null, { configurationId: this.flowId });
        return session;
      } catch (error) {
        throw error;
      }
    }
  }
  
  
  renderUserConsent() {
    this.incode.renderUserConsent(this.container, {
      onSuccess: () => this.renderDocumentSelector(),
      title: "ID Verification Consent",
      text: "By continuing, you agree to our privacy policy.",
      onCancel: () => {},
      // onSuccess: this.renderBackIDCamera(), // after we succesfully get the front of the id, let's scan the back side
      // onError: showError,
      session: this.session,  // the session token we retrieved before
      customCheck: null
    });
  }

  showConsent() {
    const handleConsentGiven = () => {
      console.log("Combined consent given.");
    };
  
    // this.hideUnwantedDivs();

    // Define the configuration options for the consent screen
    const consentOptions = {
      token: this.session,
      onSuccess: () => this.renderDocumentSelector(),
      consentId: environment.idv.consentId, // id of a consent created in dashboard
    };
  
    this.incode.renderCombinedConsent(this.container, consentOptions);

    setTimeout(() => this.observeConsentScreen(), 0);
  }

  

  observeConsentScreen() {
    const targetNode = this.container; // The parent container where consent elements are added

    if (!targetNode) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          this.removeDivByText(targetNode, "I consent to the collection"); // Replace with the actual text to match
        }
      });
    });

    observer.observe(targetNode, { childList: true, subtree: true });

    // Initial check in case elements are already present
    this.removeDivByText(targetNode, "I consent to the collection");
  }

  removeDivByText(container: HTMLElement, searchText: string) {
    const paragraphs = container.querySelectorAll("p");

    paragraphs.forEach((p) => {
      if (p.textContent?.trim().includes(searchText)) {
        let parentDiv = p.closest("div");

        // Keep moving up until we find a div that also contains a checkbox
        while (parentDiv && !parentDiv.querySelector("input[type='checkbox']")) {
          parentDiv = parentDiv.parentElement as HTMLDivElement;
        }

        if (parentDiv) {
          parentDiv.remove();
        }
      }
    });
  }

  // hideUnwantedDivs() {
  //   // Immediately remove the unwanted divs
  //   const unwantedDivs = document.querySelectorAll(".sc-gtJxfw");
  //   unwantedDivs.forEach(div => div.remove());
  // }

  renderBiometricConsent() {
    this.incode.renderBiometricConsent(this.container, {
      onSuccess: () => this.renderDocumentSelector(),
      // title: "ID Verification Consent",
      // text: "By continuing, you agree to our privacy policy.",
      onCancel: () => {},
      // onSuccess: this.renderBackIDCamera(), // after we succesfully get the front of the id, let's scan the back side
      // onError: showError,
      token: this.session,  // the session token we retrieved before
      regulationType: 'US_California'
    });
  }

  renderDocumentSelector() {
    this.incode.renderDocumentSelector(this.container, {
      onSuccess: () => this.processId(),
      onError: () => this.documentScanFailed(),
      // onSuccess: this.renderBackIDCamera(), // after we succesfully get the front of the id, let's scan the back side
      // onError: showError,
      token: this.session,  // the session token we retrieved before
      numberOfTries: 3,
      showTutorial: true,
      fullScreen: false
    });
  }

  documentScanFailed() {
      alert('document scan failed')
  }


  renderFrontIDCamera() {
      this.incode.renderCamera("front", this.container, {
          onSuccess: (arg: any) => {
            console.log('arg', arg)
            if(!arg.skipBackIdCapture) {
              this.renderBackIDCamera()
            } else {
              this.processId()
            }
          },
          // onSuccess: this.renderBackIDCamera(), // after we succesfully get the front of the id, let's scan the back side
          // onError: showError,
          token: this.session,  // the session token we retrieved before
          numberOfTries: 3,
          showTutorial: true
      });
  }

  renderBackIDCamera() {
      this.incode.renderCamera("back", this.container, {
          onSuccess: () => this.processId(), // At this point we have both sides succesfully scanned, let incode process the data 
          // onError: showError,
          token: this.session,     // the session token we retrieved before
          numberOfTries: 3,
          showTutorial: true
      });
  }

  renderSelfieCamera() {
    this.incode.renderCamera("selfie", this.container, {
      onSuccess: () => {
        this.incode.getFinishStatus( this.flowId, { token : this.session.token }); 
        this.idVerificationCompleted.emit(VerificationStatus.ThankYouPage);
      },
      // onError: showError,
      token: this.session,
      numberOfTries: 3,
    });
  }

  async processId() {
    if(this.container) {
      this.container.innerHTML = "<p>Loading...</p>";
      await this.incode.processId({ token: this.session.token });
      this.container.innerHTML = "";
      this.renderSelfieCamera();
    }
      
  }

}
